// extracted by mini-css-extract-plugin
export default {"img":"rDhjfP5Q5Re0Oh8_F88c","backgroundImg":"nXagRfOTEFMp0lRvbTW6"};